"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { UniversalButton } from "../../common/UniversalButton";
import { UniversalFoodIndicator } from "../../common/UniversalFoodIndicators";
import ImageComponent from "@/components/ui/image";
import { useRouter } from "next/navigation";
import Link from "next/link";
import SectionHeading from "../../explore-sections/shared/heading";
import { sendGAEvent } from "@next/third-parties/google";
export interface Product {
  image: string;
  title: string;
  subtitle: string;
  price: number;
  rating: number;
  totalUsers: number;
  discount?: number;
  tags: string[];
  baker: string;
  bestSeller?: boolean;
  banner?: string;
  overlayText?: string;
  overlaySubText?: string;
  type: "veg" | "non_veg" | "";
  vendorId?: string | number;
  id?: string | number;
  product_type: string | number;
  product_subtype: string | number;
  product_type_name?: string;
  product_subtype_name?: string;
  slug: string;
  vendorSlug: string;
}
export interface ProductsSectionProps {
  products?: Product[];
  quickPicksSection: boolean;
  tittle?: string;
  categories: CakeFilters[];
  selectedcategories: CakeFilters[];
  handleCategoryChange: (category: CakeFilters) => void;
  buttonClickFunction: () => void;
  buttonActive: boolean;
}
interface CakeFilters {
  title: string;
  subtitle: string;
  image: string;
  type: string;
  id: string;
}
const ProductGrid: React.FC<ProductsSectionProps> = t0 => {
  const $ = _c(21);
  const {
    quickPicksSection,
    tittle,
    products: t1,
    buttonActive,
    buttonClickFunction
  } = t0;
  const products = t1 === undefined ? [] : t1;
  const [isClient, setIsClient] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const router = useRouter();
  let t2;
  if ($[0] !== router) {
    t2 = product => {
      router.push(`/listing/cake?id=${product.product_type}&product_subtype_id=${product.product_subtype}`);
    };
    $[0] = router;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleImageClick = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth < 1024);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  const mobileItemCount = quickPicksSection ? 4 : 3;
  const displayedProducts = (isSmallScreen ? products?.slice(0, mobileItemCount) : quickPicksSection ? products?.slice(0, 6) : products)?.filter(_temp);
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsClient(true);
    };
    t6 = [];
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  useEffect(t5, t6);
  if (!isClient) {
    return null;
  }
  const t7 = "lg:px-2 w-full mt-[2rem] lg:pb-[3rem] pb-[2rem] ";
  let t8;
  if ($[6] !== tittle) {
    t8 = tittle && <SectionHeading heading={` ${tittle}S `} classNames="lg:text-2xl text-sm  text-[#3E3F41] font-outfit font-normal ml-3 mb-4 uppercase" />;
    $[6] = tittle;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = `${quickPicksSection ? "bg-v2-surface lg:p-4 max-lg:px-2 rounded-lg" : ""}`;
  const t10 = `grid ${quickPicksSection ? "grid-cols-2 md:grid-cols-2 lg:grid-cols-3 lg:gap-4 gap-2" : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:gap-6"}`;
  const t11 = displayedProducts && displayedProducts.map(product_1 => <div key={product_1.title} className={`bg-white rounded-lg overflow-hidden  ${quickPicksSection ? "p-2 " : "p-2"}`}><Link href={`/${product_1.vendorSlug}/product/${product_1.slug}`} className={`flex w-full ${quickPicksSection ? "max-sm:flex-col" : ""}`} onClick={() => {
      sendGAEvent("event", "select_item", {
        currency: "INR",
        value: Number(product_1.price),
        items: [{
          item_id: String(product_1.id),
          item_name: product_1.title,
          item_brand: product_1.baker,
          item_category: product_1.product_type_name,
          item_category2: product_1.product_subtype_name,
          price: Number(product_1.price),
          quantity: 1,
          location: "home_page"
        }]
      });
    }}><div className={`${quickPicksSection ? "max-sm:w-full w-1/2 max-sm:h-32 max-sm:mb-2" : "md:w-1/2  max-sm:h-28 w-32"} lg:h-48 rounded-lg overflow-hidden`}><div className="rounded-lg w-full relative h-full cursor-pointer" onClick={() => handleImageClick(product_1)}><ImageComponent width={500} height={500} src={product_1.image || "/placeholder.svg"} alt={product_1.title} sizes="(max-width: 768px) 50vw, (max-width: 1200px) 33vw, 250px" className="lg:w-full h-full object-cover transition-transform rounded-lg duration-300 hover:scale-105" />{product_1.banner && <div className="absolute top-2 right-2 bg-white md:px-2 md:py-1 px-[6px] py-[2px] rounded-full md:text-sm text-xs font-semibold text-[#079ea6] border font-outfit italic border-yellow-400 shadow">{product_1.banner?.replace(/\sUSE\s.*/i, "")}</div>}{product_1.overlayText && <div className="absolute bg-gradient-to-t from-black to-transparent shadow-lg bottom-0 left-0 right-0 text-white px-4 py-2 lg:text-lg text-xs font-semibold text-left font-serif whitespace-nowrap ">{product_1.overlayText}</div>}</div></div><div className={`${quickPicksSection ? "max-sm:w-full w-1/2 max-sm:px-0" : "md:w-1/2 flex-1 max-sm:px-3"} lg:px-4 max-sm:py-0 md:h-40 lg:h-48 max-h-28 flex flex-col justify-between items-start`}><div className="w-full h-full flex flex-col "><h3 className="lg:text-xl text-sm font-medium lg:text-[#303030] text-[#4A4A4A] lg:truncate font-lora mb-2 min-h-10" title={product_1.title}>{product_1.title?.split(" ").slice(0, 5).join(" ")}{product_1.title?.split(" ").length > 5 && "..."}</h3><div className="lg:text-lg text-base font-outfit font-medium text-[#2C2C2C]">₹{product_1.price}</div></div><div className="flex lg:flex-col flex-row max-lg:items-end justify-end max-lg:space-x-1 h-full  "><UniversalFoodIndicator type={product_1.type} className="lg:p-2 lg:pt-8" /><div className="flex flex-nowrap text-nowrap gap-2 ">{product_1.tags?.slice(0, 2).map(_temp2)}{product_1.tags?.length > 2 && <span className="text-[#5a5a5a] font-outfit italic font-medium lg:text-base text-xs ">...</span>}</div></div></div></Link><Link href={`/${product_1.vendorSlug}/${product_1.vendorId}`} className="lg:px-4 px-2 py-3 mt-2"><div className="text-[#037a6a] lg:text-xl text-sm font-normal flex items-center w-full"><span className="truncate font-lora">By {product_1.baker}</span><span className="ml-1 text-base">→</span></div></Link></div>);
  let t12;
  if ($[8] !== t10 || $[9] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== buttonActive || $[12] !== buttonClickFunction) {
    t13 = buttonActive && <div className="flex justify-center w-full lg:py-12 py-4 lg:hidden"><UniversalButton text="VIEW ALL" classNames="lg:text-xl font-lora bg-[#037A6A] text-base text-[#F3F3F3] lg:px-10 lg:py-4 px-3 py-2 rounded-lg font-extrabold hover:bg-[#025a4f] transition-all duration-300 transform hover:scale-105" onClick={buttonClickFunction} variant="custom" /></div>;
    $[11] = buttonActive;
    $[12] = buttonClickFunction;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t12 || $[15] !== t13 || $[16] !== t9) {
    t14 = <div className={t9}>{t12}{t13}</div>;
    $[14] = t12;
    $[15] = t13;
    $[16] = t9;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t14 || $[19] !== t8) {
    t15 = <div className={t7}>{t8}{t14}</div>;
    $[18] = t14;
    $[19] = t8;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  return t15;
};
export default ProductGrid;
function _temp(product_0) {
  return product_0.slug && product_0.vendorSlug;
}
function _temp2(tag, index) {
  return <span key={index} className="text-[#5a5a5a] font-outfit italic font-medium lg:text-base text-xs border-r-[1px] border-[#d9d9d9] lg:pr-2 pr-1">{tag}</span>;
}